import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FormatBoldSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FormatBoldSVG;
